(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // ZKS – Mobilde tekli/ikili görünüm ikonlarını gizle
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const toolbar = document.querySelector('.results-toolbar');
    if (!toolbar) return;
    const buttons = toolbar.querySelectorAll('button');
    if (buttons.length > 1) {
      for (let i = 1; i < buttons.length; i++) {
        buttons[i].style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
